// extracted by mini-css-extract-plugin
module.exports = {"shadow":"_1xWR6MPxiAo88C81jT94gl"};